import {Observable} from 'rxjs';

import IConfigStore from '../../Config/Interfaces/IConfigStore';
import FrameStatus  from '../Constants/FrameStatus';

const handleFrameStatusChange = (
    fullscreenElement: HTMLElement,
    nextFrameStatus: FrameStatus
) => {
    if (fullscreenElement === null) {
        fullscreenElement = document.body;
    }

    switch (nextFrameStatus) {
        case FrameStatus.FULLSCREENED:
            enterFullscreen(fullscreenElement);

            break;
        case FrameStatus.WINDOWED:
            exitFullscreen();

            break;
    }
};

const enterFullscreen = (fullscreenElement: HTMLElement) => {
    const fn =
        fullscreenElement.requestFullscreen ||
        (fullscreenElement as any).msRequestFullscreen ||
        (fullscreenElement as any).mozRequestFullScreen ||
        fullscreenElement.webkitRequestFullscreen;

    if (typeof fn === 'function') fn.call(fullscreenElement);
};

const exitFullscreen = () => {
    const fn =
        document.exitFullscreen ||
        (document as any).msExitFullscreen ||
        (document as any).mozCancelFullScreen ||
        document.webkitExitFullscreen;

    if (typeof fn === 'function') fn.call(document);
};

const subscribeToFrameStatusChange = (
    frameStatusChange$: Observable<FrameStatus>,
    config: IConfigStore
) =>
    frameStatusChange$
        .subscribe((frameStatus) => handleFrameStatusChange(config.value.behaviour.fullscreenElement, frameStatus));

export default subscribeToFrameStatusChange;